module.exports = __webpack_public_path__ + "media/customizations/harvestgreen/logo-new-bede79f597551c113efb36210c68e06d.png";